import styled from 'styled-components';

import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

export const Text = styled.span`
  color: var(--text-disabled);
  font-family: var(--font-nort);
  ${typographyV2.uiXs};
`;
